@if (cardModalService.showModal() && cardData) {
    <section class="wk-cm__card-panel__jb__dates">
        <div
            class="wk-cm__card-panel__jb__target-start-date calendar_data date_format"
            [class.calendar_data--disabled]="!canEditStartDate()"
            (click)="targetStartDateCalendar.toggle()"
            (keydown.enter)="targetStartDateCalendar.toggle()"
            aria-hidden="true"
        >
            @if (cardModalService.cardModalFormGroup().get("targetStartDate")?.value || !this.canEditStartDate()) {
                <tooltip-pds3
                    mode="description"
                    position="top"
                    [openDelay]="600"
                    [closeDelay]="50"
                    targetSelector=".wk-cm__card-panel__jb__target-start-date"
                    flowClass="tooltip--non-interactive"
                >
                    {{ (this.canEditStartDate() ? "JobsAndBilling.TargetStartDate" : "Tooltips.DisabledJobsSecurity") | translate }}
                </tooltip-pds3>
            }
            <kendo-datepicker
                #targetStartDateCalendar
                [format]="dateFormat"
                [placeholder]="'JobsAndBilling.TargetStartDate' | translate"
                [disabledDates]="disabledStartDates"
                formControlName="targetStartDate"
                wk-auto-width
            >
                <kendo-datepicker-messages today="{{ 'Code.Today' | translate }}" toggle="{{ 'CardModal.ToggleCalendar' | translate }}" />
            </kendo-datepicker>
        </div>
        <div
            class="wk-cm__card-panel__jb__target-end-date calendar_data date_format"
            [class.calendar_data--disabled]="!canEditEndDate()"
            (click)="targetEndDateCalendar.toggle()"
            (keydown.enter)="targetEndDateCalendar.toggle()"
            aria-hidden="true"
        >
            @if (cardModalService.cardModalFormGroup().get("targetEndDate")?.value || !this.canEditEndDate()) {
                <tooltip-pds3
                    mode="description"
                    position="top"
                    [openDelay]="600"
                    [closeDelay]="50"
                    targetSelector=".wk-cm__card-panel__jb__target-end-date"
                    flowClass="tooltip--non-interactive"
                >
                    {{ (this.canEditEndDate() ? "JobsAndBilling.TargetEndDate" : "Tooltips.DisabledJobsSecurity") | translate }}
                </tooltip-pds3>
            }
            <kendo-datepicker
                #targetEndDateCalendar
                [format]="dateFormat"
                [placeholder]="'JobsAndBilling.TargetEndDate' | translate"
                [disabledDates]="disabledEndDates"
                formControlName="targetEndDate"
                wk-auto-width
            >
                <kendo-datepicker-messages today="{{ 'Code.Today' | translate }}" toggle="{{ 'CardModal.ToggleCalendar' | translate }}" />
            </kendo-datepicker>
        </div>
        <div class="wk-cm__card-panel__jb__number-of-days-since-start calendar_data">
            <tooltip-pds3
                mode="description"
                position="top"
                [openDelay]="600"
                [closeDelay]="50"
                targetSelector=".wk-cm__card-panel__jb__number-of-days-since-start"
                flowClass="tooltip--non-interactive"
            >
                {{ "Tooltips.NumberOfDaysSinceStart" | translate }}
            </tooltip-pds3>
            <wk-icon-stopwatch-sprite-pds3 />
            <icon-pds3 name="wk-icon-stopwatch" />
            <span class="calender_info">{{ calculatedFields.daysSinceReady }} {{ "CardModal.Days" | translate }}</span>
        </div>
        <div class="wk-cm__card-panel__jb__step-warning calender_data">
            <tooltip-pds3
                mode="description"
                [openDelay]="600"
                [closeDelay]="50"
                position="top"
                targetSelector=".wk-cm__card-panel__jb__step-warning"
                flowClass="tooltip--non-interactive"
            >
                {{ "Tooltips.NumberOfDaysSinceColumn" | translate }}
            </tooltip-pds3>
            <kendo-datepicker
                #snoozeAlertCalendar
                [title]="' '"
                adaptiveMode="auto"
                formControlName="quietDate"
                [disabledDates]="disabledDates"
                [readonly]="!calculatedFields.isStepWarning && !calculatedFields?.isStepAlert"
                (valueChange)="onChange($event)"
                [class.no-warning]="!calculatedFields.isStepWarning"
                [class.no-alert]="!calculatedFields.isStepAlert"
                wk-auto-width
            >
                <kendo-datepicker-messages today="{{ 'Code.Today' | translate }}" toggle="{{ 'CardModal.ToggleCalendar' | translate }}" />
            </kendo-datepicker>
        </div>
        <div
            class="wk-cm__card-panel__jb__date-received calendar_data inbox_format"
            (click)="dateReceivedCalendar.toggle()"
            (keydown.enter)="dateReceivedCalendar.toggle()"
            aria-hidden="true"
        >
            @if (cardModalService.cardModalFormGroup().get("documentsReceivedDate")?.value) {
                <tooltip-pds3
                    mode="description"
                    position="top"
                    [openDelay]="600"
                    [closeDelay]="50"
                    targetSelector=".wk-cm__card-panel__jb__date-received"
                    flowClass="tooltip--non-interactive"
                >
                    {{ "CardModal.DateReceived" | translate }}
                </tooltip-pds3>
            }
            <kendo-datepicker
                #dateReceivedCalendar
                adaptiveMode="auto"
                [format]="dateFormat"
                [placeholder]="'CardModal.DateReceived' | translate"
                formControlName="documentsReceivedDate"
                wk-auto-width
            >
                <kendo-datepicker-messages today="{{ 'Code.Today' | translate }}" toggle="{{ 'CardModal.ToggleCalendar' | translate }}" />
            </kendo-datepicker>
        </div>
    </section>
    <div class="wk-cm__card-panel__jb-body">
        <div class="wk-cm__card-panel__jb-left">
            <tabs-pds3 htmlId="tabs-follow-up" class="wk-cm__card-panel__jb__follow-up" srLabel="follow-up-tabs" selectedTabId="FollowUpInfo">
                <tablist-pds3>
                    <tab-pds3 tabId="FollowUpInfo">{{ "CardModal.FollowUpInfo" | translate }}</tab-pds3>
                    <tab-pds3 tabId="JobStatusHistory">{{ "CardModal.JobStatusHistory" | translate }}</tab-pds3>
                </tablist-pds3>
                <tab-line-pds3 />
                <tab-panels-pds3>
                    <tab-panel-pds3 panelId="FollowUpInfo">
                        <wk-jobs-billing-follow-up-info
                            [cardData]="cardData"
                            (statusChanged)="updateJobStatus($event)"
                            (priorityChanged)="updateJobPriority($event)"
                        />
                    </tab-panel-pds3>
                    <tab-panel-pds3 panelId="JobStatusHistory" class="wk-cm__card-panel__tax__return-status-history">
                        <wk-status-history [statuses]="statusHistory" />
                    </tab-panel-pds3>
                </tab-panels-pds3>
            </tabs-pds3>

            <wk-jobs-billings-notes-panel [id]="cardData?.job?.id" />
        </div>
        <div class="wk-cm__card-panel__jb-right fancy-scrollbar-newUI fancy-scrollbar-small">
            <accordion-pds3>
                <accordion-item-pds3
                    [isOpen]="accordionsService.getAccordionState()(`Accordion_Jobs_ContactInformation_${cardData?.id}`) ?? false"
                    (userRequest)="accordionsService.setAccordionState(`Accordion_Jobs_ContactInformation_${cardData?.id}`, $event)"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>{{ "CardModal.ContactInfo" | translate }}</accordion-item-header-pds3>
                    <div *accordionItemBodyPds3>
                        <wk-groups-methods-panel [type]="CardPanelType.Contact" />
                        <wk-assignees-jobs-panel [type]="CardPanelType.Contact" />
                    </div>
                </accordion-item-pds3>

                <accordion-item-pds3
                    [isOpen]="accordionsService.getAccordionState()(`Accordion_JobsAssignees_Assignees_${cardData?.id}`) ?? true"
                    (userRequest)="accordionsService.setAccordionState(`Accordion_JobsAssignees_Assignees_${cardData?.id}`, $event)"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>{{ "CardModal.AssignedTo" | translate }}</accordion-item-header-pds3>
                    <div *accordionItemBodyPds3><wk-assignees-jobs-panel [type]="CardPanelType.Job" /></div>
                </accordion-item-pds3>

                @if (isAnyGroupEnabled()) {
                    <accordion-item-pds3
                        [isOpen]="accordionsService.getAccordionState()(`Accordion_Jobs_Groups_${cardData?.id}`) ?? true"
                        (userRequest)="accordionsService.setAccordionState(`Accordion_Jobs_Groups_${cardData?.id}`, $event)"
                    >
                        <accordion-item-header-pds3 *accordionItemHeading2Pds3>{{ "JobsAndBilling.Group" | translate }}</accordion-item-header-pds3>
                        <div *accordionItemBodyPds3><wk-groups-methods-panel [type]="CardPanelType.Job" /></div>
                    </accordion-item-pds3>
                }
            </accordion-pds3>
        </div>
    </div>
}
